import {getRecognitionAttempts} from './getRecognitionAttempts'

export const faces = {
  getRecognitionAttempts,
}
